import React from 'react';
import { ChevronsLeft, ChevronLeft, ChevronRight, ChevronsRight } from 'react-feather';
import './PaginationNav.scss'; // Add styles for pagination if needed

const PaginationNav = ({ currentPage, totalPages, onPageChange }) => {
    const handleFirst = () => {
        if (currentPage > 1) {
            onPageChange(1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const handleLast = () => {
        if (currentPage < totalPages) {
            onPageChange(totalPages);
        }
    };

    const handlePageClick = (page) => {
        if (page !== currentPage) {
            onPageChange(page);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(
                <button
                    key={i}
                    className={`pagination-button ${i === currentPage ? 'active' : ''}`}
                    onClick={() => handlePageClick(i)}
                >
                    {i}
                </button>
            );
        }
        return pages;
    };

    return (
        <div className="pagination">
            <button
                className="pagination-button"
                onClick={handleFirst}
                disabled={currentPage === 1}
                aria-label="First Page"
            >
                <ChevronsLeft />
            </button>
            <button
                className="pagination-button"
                onClick={handlePrevious}
                disabled={currentPage === 1}
                aria-label="Previous Page"
            >
                <ChevronLeft />
            </button>
            {renderPageNumbers()}
            <button
                className="pagination-button"
                onClick={handleNext}
                disabled={currentPage === totalPages}
                aria-label="Next Page"
            >
                <ChevronRight />
            </button>
            <button
                className="pagination-button"
                onClick={handleLast}
                disabled={currentPage === totalPages}
                aria-label="Last Page"
            >
                <ChevronsRight />
            </button>
        </div>
    );
};

export default PaginationNav;